// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._75sAC{position:relative;margin:24px -16px 32px}._75sAC a[href^=tel]{color:inherit;text-decoration:none}@media screen and (min-width:768px){._75sAC{margin:40px 0}}._75sAC *{margin-top:0;margin-bottom:0}._75sAC iframe{width:100%!important;border:0!important}._75sAC.iCYT\\+:after{display:block;padding-bottom:56.25%;content:\"\"}._75sAC.iCYT\\+ iframe{position:absolute;top:0;left:0;width:100%;height:100%}[data-a11y] ._75sAC{margin-top:48px;margin-bottom:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxCustomEmbed": "_75sAC",
	"is16x9": "iCYT+"
};
module.exports = ___CSS_LOADER_EXPORT___;
